export default __webpack_public_path__ + "static/media/manage-live.7c0eea79.svg";